import './PointsDisplay.css';
import * as React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faStar} from "@fortawesome/free-solid-svg-icons";
import NumberFlow from '@number-flow/react'
import continuous from 'number-flow'

interface Props {
  points: number,
}

function PointsDisplay(props: Props) {
  return (
      <div className={"card-points"}>
        <NumberFlow plugins={[continuous]} value={props.points} />
        <FontAwesomeIcon className={"ms-1"} icon={faStar} />
      </div>
  )
}

export default PointsDisplay;